const events = {
    showNotification: "showNotification",
    logoutCurrentUser: "logoutCurrentUser",
    routerPush: "routerPush",
  };
  
  export default events;